import { all, takeEvery } from "redux-saga/effects";
import { RedirectExternalAction, REDIRECT_EXTERNAL } from "@/actions/redirectExternal";


export function handleRedirectExternal() {
  return function* (action: RedirectExternalAction) {
    const { payload } = action
    
    window.location.assign(payload.url)
    yield
  }
}

export default function* redirectExternalSaga() {
  yield all([
    takeEvery(REDIRECT_EXTERNAL, handleRedirectExternal()),
  ])
}
